import {PortDeclChunk} from "../../chunks/types/PortDeclChunk";

export function getSpreadOpFromPortDeclChunk(
  portDeclChunk: PortDeclChunk
): string | null {
  const {
    captures: {
      1: spreadOpChunk
    }
  } = portDeclChunk;
  return spreadOpChunk ?
    spreadOpChunk.captures[0] :
    null;
}
